import { Grid, Paper, Typography, Stack, Chip } from "@mui/material"
import { classeSocialKeyToLabel } from "../../../detalhes-do-projeto/filtros/classe-social"
import { IClasseSocial } from "../../../../../../../application/models"
// Icon
import BarChartIcon from '@mui/icons-material/BarChart'

export const RecorteClasseSocialFilterPreview = (props: {
    classeSocialFilter?: IClasseSocial[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Classe Social
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.classeSocialFilter && props.classeSocialFilter.map((classeSocial, i) => (
                                <Chip
                                    key={i}
                                    icon={<BarChartIcon />}
                                    label={classeSocialKeyToLabel(classeSocial).toUpperCase()}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}